<app-slider></app-slider>
<app-slider-mobile></app-slider-mobile>
<app-banner-planes></app-banner-planes>
<app-servicios-carousel></app-servicios-carousel>
<app-testimonios></app-testimonios>
<app-banner-blog></app-banner-blog>
<app-faq-toggles-home></app-faq-toggles-home>
